import React, { useEffect, useState, useContext } from "react";
import "./Deleteresume.scss";
import Modal from "react-bootstrap/Modal";
import { useHistory, useParams, useRouteMatch } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteResumeByID,
  getAllResumes,
} from "../../Store/Actions/ResumeActions";
import { RESUME_DELETE_RESET } from "../../Store/Constants/ResumeConstants";
import { ResumePopupContext } from "../../Context/resumePopupContext";
import { deleteCoverByID } from "../../Store/Actions/CoverLetterActions";
import { userParticularGet } from "../../Store/Actions/UserActions";

function Deleteresume(props) {
  const history = useHistory();
  const loader = useSelector((state) => state.loading);
  const deleteData = useSelector((state) => state.deleteResume);
  const deleteCoverData = useSelector((state) => state.coverDelete);

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const spinnerStyle = {
    maxWidth: "15px",
    position: "absolute",
    top: "50%",
    transform: "translate(23%, -54%)",
  };

  const handleDelete = () => {
    if (props && props.cover == "cover") {
      dispatch(deleteCoverByID(props.deleteId));
    } else {
      dispatch(deleteResumeByID(props.deleteId));
    }
  };

  useEffect(() => {
    if (
      deleteCoverData &&
      deleteCoverData.data &&
      deleteCoverData.data.success
    ) {
      dispatch(userParticularGet());

      setTimeout(() => {
        props.hideResume();
        if (props.page != "home") {
          history.push("/home");
        }
      }, [10]);
    }
  }, [deleteCoverData]);

  useEffect(() => {
    if (deleteData && deleteData.data && deleteData.data.success) {
      dispatch(userParticularGet());

      setTimeout(() => {
        props.hideResume();
        if (props.page != "home") {
          history.push("/home");
        }
      }, [10]);
    }
  }, [deleteData]);

  useEffect(() => {
    if (loader.loading) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [loader]);

  return (
    <>
      <Modal
        show={props.deleteResume}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        keyboard={true}
        onHide={props.hideResume}
        onEscapeKeyDown={props.hideResume}
      >
        <Modal.Body>
          <img
            onClick={props.hideResume}
            src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/close.svg`}
            alt="closeicon"
            className="close"
          />
          <div className="container">
            <div className="text-center">
              <h4 className="maintitle deletetitle">
                {props && props.cover == "cover"
                  ? "Delete Cover Letter"
                  : "Delete Resume"}
              </h4>
              <p className="titledesc deletedesc">
                Are you sure you want to Delete this{" "}
                {props && props.cover == "cover" ? " Cover Letter" : "Resume"} ?
                <br />
                Once Deleted this Resume cannot be Restored.
              </p>
            </div>
            <div className="row">
              <div className="col-md-6 col-sm-12 col-12">
                <button
                  onClick={props.hideResume}
                  className="btn primarybtn mainborder float-right   p-14 w-75 delbtn"
                >
                  Cancel
                </button>
              </div>
              <div className="col-md-6 col-sm-12 col-12">
                {loading ? (
                  <button
                    disabled
                    className="btn primarybtn  w-75 mainborder delbtn bgsuccess text-white position-relative"
                  >
                    <span className="resume-options">Deleting...</span>
                    <img
                      src="/images/loadwhite.gif"
                      style={spinnerStyle}
                      alt="loading"
                    />
                  </button>
                ) : (
                  <button
                    className="btn primarybtn  w-75 mainborder delbtn bgsuccess text-white"
                    onClick={handleDelete}
                  >
                    {props && props.cover == "cover"
                      ? " Delete Cover Letter"
                      : "Delete resume"}
                  </button>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default Deleteresume;
